import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const User = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [editUser, setEditUser] = useState(null);
   const [isLoading, setIsLoading] = useState(false);
  function tog_list() {
    setmodal_list(!modal_list);
  }
const [machineData, setMachineData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [roles, setRoles] = useState([]);

  const fetchCompany = async () => {
    try {
         setIsLoading(true)
      const response = await fetch("https://api.hanoch.in/api/company", {
      });

      if (response.ok) {
        const data = await response.json();
        setCompanyData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
        setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);
useEffect(() => {
  const fetchRoles = async () => {
    try {
      const response = await fetch(
        "https://api.hanoch.in/users/user-role-choice/"
      );

      if (response.ok) {
        const data = await response.json();
        setRoles(data?.roles || []);
      } else {
        console.error("Failed to fetch roles");
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  fetchRoles();
}, []);

const fetchMachine = async (companyId) => {
  try {
    const response = await fetch(
      `https://api.hanoch.in/api/machines/by-company/?id=${companyId}`
    );

    if (response.ok) {
      const data = await response.json();
      setMachineData(data.data);
    } else if (response.status === 401) {
      localStorage.removeItem("authUser");
      localStorage.removeItem("admin");
    } else {
      console.error("Error fetching machine data:", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching machine data:", error);
  }
};


  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    role: "",
    company: "",
    machines: [],
    password: "",
  });


  useEffect(() => {
    if (editUser) {
      setFormData({
        first_name: editUser.first_name,
        last_name: editUser.last_name,
        email: editUser.email,
        phone: editUser.phone,
        role: editUser.role,
        company: editUser.company_name,
        machines: editUser.machine_name,
        password: editUser.password,
      });
    } else {
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        role: "",
        company: "",
        machines:[],
        password: "",
      });
    }
  }, [editUser]);

const authToken=localStorage.getItem("access");


  const handleSubmit = async (e) => {
    e.preventDefault();
   setIsLoading(true);
 const payload = {
  first_name: formData?.first_name,
    last_name: formData?.last_name,
    email: formData?.email,
    phone: formData?.phone,
    role: formData?.role,
    company: formData?.company,
    machines:  formData.machines,
    password: formData?.password,
  };
//  console.log("payload",payload)
    try {
      const apiUrl = editUser
        ? `https://api.hanoch.in/user/${editUser.id}`
        : "https://api.hanoch.in/users/users/";

      const response = await fetch(apiUrl, {
        method: editUser ? "PATCH" : "POST",
          headers: {
    "Content-Type": "application/json",
   // Authorization: `Bearer ${authToken}`, // optional if your API requires it
  },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();

      if (response.ok) {
        toast.success(responseData.message);
        tog_list();
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          role: "",
          company: "",
          machines: [],
          password: "",
        });
        fetchUser();
      } else {
        toast.error(`Error: ${responseData.error}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const [userData, setUserData] = useState([]);

  const fetchUser = async () => {
    try {
      // Fetch data from your API
      const response = await fetch("https://api.hanoch.in/users/users", {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
        // },
      });

      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setUserData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const handleDeleteUser = async (userId) => {
    try {
      // Make API request to delete the user
      const response = await fetch(
        `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/delete/user/${userId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${authToken}`, // Replace with your actual token
          },
        }
      );

      if (response.ok) {
        toast.success("User Deleted Successfully");
        // If the deletion was successful, refresh the user data
        fetchUser();
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        toast.error("Error deleting user:", response.statusText);
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUsers = userData.filter(
    (user) =>
      user.first_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      user.last_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      user.email?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

    
const handleInputChangeWrapper = (e) => {
  const { id, value } = e.target;
  setFormData({ ...formData, [id]: value });

  if (id === "company") {
    fetchMachine(value); // value is company ID
  }
};
  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
 // console.log("cuurentItems",currentItems);
  // console.log(userData);

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Users" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">Add, Edit & Remove User</h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={() => tog_list()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add User
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
 {isLoading ? (
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="customer_name">
                              User
                            </th>
                            <th className="sort" data-sort="email">
                              Email
                            </th>
                            <th className="sort" data-sort="phone">
                              Phone
                            </th>
                            <th className="sort" data-sort="phone">
                              Role
                            </th>
                            <th className="sort" data-sort="phone">
                              Company Name
                            </th>
                            <th className="sort" data-sort="phone">
                              Machine Name
                            </th>
                            <th className="sort" data-sort="date">
                              Joining Date
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {currentItems === undefined ? (
                            <tr>
                              <td colSpan="8" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No content found
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((user, index) => (
                              <tr key={index}>
                                <td className="customer_name">
                                  
                                  {user.first_name} {user.last_name}
                                </td>
                                <td className="email">{user.email}</td>
                                <td className="phone">{user.phone}</td>
                                <td className="">{user.role}</td>

                                <td>
                                  {user.company_name &&
                                    user.company_name}
                                </td>
                                <td>
                                  {user.machine_names &&
                                    user?.machine_names}
                                </td>

                                <td className="date">
                                  {user?.date}
                                  {/* {user.created_at.split("T")[0]} */}
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={() => {
                                          setEditUser(user);
                                          setmodal_list(true);
                                        }}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                    <div className="remove">
                                      <button
                                        className="btn btn-danger remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                        onClick={() =>
                                          handleDeleteUser(user.id)
                                        }
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>
                    )}
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      <Modal
        isOpen={modal_list}
        toggle={() => {
          setmodal_list(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            tog_list();
          }}
        >
          {editUser ? "Edit User" : "Add User"}
        </ModalHeader>
        <form className="tablelist-form">
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="firstname-field" className="form-label">
                First Name
              </label>
              <input
                type="text"
                id="first_name"
                className="form-control"
                placeholder="First Name"
                value={formData.first_name}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="lastname-field" className="form-label">
                Last Name
              </label>
              <input
                type="text"
                id="last_name"
                className="form-control"
                placeholder="Last Name"
                value={formData.last_name}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email-field" className="form-label">
                Email
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Enter Email"
                value={formData.email}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phone-field" className="form-label">
                Phone
              </label>
              <input
                type="text"
                id="phone"
                className="form-control"
                placeholder="Enter Phone no."
                value={formData.phone}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>

           <div className="mb-3">
  <label htmlFor="role" className="form-label">
    Role
  </label>

  <select
    id="role"
    name="role"
    className="form-control"
    value={formData.role}
    onChange={handleInputChangeWrapper}
    required
  >
    <option value="">Select role</option>

    {roles.map((role) => (
      <option key={role.value || role} value={role.value || role}>
        {role.label || role}
      </option>
    ))}
  </select>
</div>

            <div className="mb-3">
              <label htmlFor="companyname-field" className="form-label">
                Company Name
              </label>
              <select
                id="company"
                className="form-control"
                placeholder="Company Name"
                value={formData.company}
                onChange={handleInputChangeWrapper}
                required
              >
                <option key="default">Select Company</option>
                {companyData.map((company, index) => (
  <option key={index} value={company.id}>
    {company.name}
  </option>
))}
              </select>
            </div>
           <div className="mb-3">
  <label htmlFor="machinename-field" className="form-label">
    Machine Name
  </label>

  {formData.company === "" ? (
    // Case 1: No company selected
    <select className="form-control" disabled>
      <option>Select a company first</option>
    </select>
  ) : machineData.length === 0 ? (
    // Case 2: Company selected but no machine data
    <select className="form-control" disabled>
      <option>No machines available</option>
    </select>
  ) : (
    // Case 3: Machines available
    <select
      id="machines"
      className="form-control"
      multiple
      value={formData.machines}
      onChange={(e) => {
        const selectedOptions = Array.from(e.target.selectedOptions).map(
          (option) => option.value
        );
        setFormData({ ...formData, machines: selectedOptions });
      }}
    >
      {machineData.map((machine) => (
        <option key={machine.id} value={machine.id}>
          {machine.name}
        </option>
      ))}
    </select>
  )}
</div>


            <div className="mb-3">
              <label htmlFor="password-field" className="form-label">
                Password
              </label>
              <input
                type="password"
                id="password"
                className="form-control"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChangeWrapper}
                required
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
               {isLoading ? (
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                onClick={handleSubmit}
              >
                {" "}
                {editUser ? "Update User" : "Add User"}
              </button>
                    )}
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default User;
